import { useId } from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

type SnippetIcon = {
  icon: IconProp;
  label: string;
  className?: string;
};

const SNIPPET_ICONS: Record<string, SnippetIcon> = {
  faq: { icon: 'question-circle', label: 'پرسش و پاسخ' },
  raiting: { icon: 'star', label: 'امتیاز', className: 'text-warning' },
  rating: { icon: 'star', label: 'امتیاز', className: 'text-warning' },
  video: { icon: 'video', label: 'ویدیو' },
  is_video: { icon: 'video', label: 'ویدیو' },
  links: { icon: 'link', label: 'لینک‌های سایت' },
  featured_snippet: { icon: 'award', label: 'فیچر اسنیپت' },
  is_featured_snippet: { icon: 'award', label: 'فیچر اسنیپت' },
  image: { icon: 'image', label: 'تصویر' },
  is_image: { icon: 'image', label: 'تصویر' },
  amp: { icon: 'bolt', label: 'نسخه AMP' },
  amp_version: { icon: 'bolt', label: 'نسخه AMP' },
  malicious: {
    icon: 'exclamation-triangle',
    label: 'نشانه مخرب',
    className: 'text-danger',
  },
  is_malicious: {
    icon: 'exclamation-triangle',
    label: 'نشانه مخرب',
    className: 'text-danger',
  },
  web_story: { icon: 'mobile-alt', label: 'وب‌استوری' },
  is_web_story: { icon: 'mobile-alt', label: 'وب‌استوری' },
  highly_cited: { icon: 'book-open', label: 'پراستناد' },
  is_highly_cited: { icon: 'book-open', label: 'پراستناد' },
  price: { icon: 'tag', label: 'قیمت' },
};

const SerpSnippetIcons = ({ data }: { data?: unknown }) => {
  const uid = useId();
  const values = Array.isArray(data)
    ? data.filter((item): item is string => typeof item === 'string' && item.length > 0)
    : [];

  if (values.length === 0) {
    return null;
  }

  return (
    <span className="d-inline-flex align-items-center gap-2">
      {values.map((value, index) => {
        const snippet = SNIPPET_ICONS[value] ?? {
          icon: 'icons' as IconProp,
          label: value,
        };
        return (
          <OverlayTrigger
            key={`${value}-${index}`}
            placement="top"
            popperConfig={{ strategy: 'fixed' }}
            overlay={
              <Tooltip
                id={`${uid}-serp-snippet-${index}`}
                style={{ position: 'fixed' }}
              >
                {snippet.label}
              </Tooltip>
            }
          >
            <span className="d-inline-flex">
              <FontAwesomeIcon
                icon={snippet.icon}
                className={snippet.className}
              />
            </span>
          </OverlayTrigger>
        );
      })}
    </span>
  );
};

export default SerpSnippetIcons;
